import { BrandEnum } from "../_common/enum/brand.enum";
import { FormTemplateTypeEnum } from "../_common/enum/forms/formTemplateType.enum";
import { FormStatusEnum } from "../_common/enum/forms/formStatus.enum";
import { IFormSectionManage } from "../_common/models/formSection";
import { API_URL } from "../_config/config.const";
import { getBody } from "../_helpers/body.helper";
import { handleResponse } from "../_helpers/handleResponse.helper";
import { getHeader } from "../_helpers/header.helper";
import { getQuery } from "../_helpers/query.helper";
import { accountService } from "./accounts.service";

const API_NAME = "form";

export const formService = {
    get,
    getProgress,
    getByToken,
    getForReview,
    getAll,
    post,
    put,
    complete,
    disable,
    getCurrentStep,
    getForTable,
    getForEmployeeTable,
    getForUserTable,
    hasConsent,
    createSample,
    createByType,
    getByType,
    createByTypeForClient,
    submit(model?: IFormSectionManage) { return model?.id ? put(model) : post(model) }
};


function hasConsent(id: number) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/hasConsent/?id=${id}`, requestOptions).then(handleResponse);
}

function get(id: number, quoteId?: number | null) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    let url = `${API_URL}/${API_NAME}/get/?id=${id}`;

    if (quoteId != null) {
        url += `&quoteId=${quoteId}`;
    }

    return fetch(url, requestOptions).then(handleResponse);
}

function getProgress(id: number) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/getProgress/?id=${id}`, requestOptions).then(handleResponse);
}

function getByToken(token: string) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    let url = `${API_URL}/${API_NAME}/getByToken/?token=${token}`;

    return fetch(url, requestOptions).then(handleResponse);
}

function getAll(query?: any) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/getAll/?${getQuery(query)}`, requestOptions).then(handleResponse);
}

function getCurrentStep() {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/getCurrentStep/`, requestOptions).then(handleResponse);
}

function getForUserTable(query: any, userId: string) {
    userId = userId || accountService.currentUserValue.id;

    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/GetForUserTable/?userId=${userId}&${getQuery(query)}`, requestOptions).then(handleResponse);
}

function getForTable(query: any, clientId?: number, formFilter?: string) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/GetForTable/?formFilter=${formFilter || ""}&clientId=${clientId}&${getQuery(query)}`, requestOptions).then(handleResponse);
}

function getForEmployeeTable(query: any, clientId?: number, formFilter?: string) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/GetForEmployeeTable/?formFilter=${formFilter || ""}&clientId=${clientId}&${getQuery(query)}`, requestOptions).then(handleResponse);
}

function getForReview(id: number) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/getForReview/?id=${id}`, requestOptions).then(handleResponse);
}

function createSample() {
    const requestOptions = { method: 'POST', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/createSample`, requestOptions).then(handleResponse);
}

function createByType(formTemplateTypeId: FormTemplateTypeEnum | string, brand: BrandEnum) {
    const requestOptions = { method: 'POST', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/createByType/?formTemplateTypeId=${formTemplateTypeId}&brand=${brand}`, requestOptions).then(handleResponse);
}
function post(model?: IFormSectionManage) {
    const requestOptions = { method: 'POST', headers: getHeader(), body: getBody(model) };
    return fetch(`${API_URL}/${API_NAME}`, requestOptions).then(handleResponse);
}

function put(model?: IFormSectionManage) {
    const requestOptions = { method: 'PUT', headers: getHeader(), body: getBody(model) };
    return fetch(`${API_URL}/${API_NAME}`, requestOptions).then(handleResponse);
}
function complete(id: number) {
    const requestOptions = { method: 'PUT', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/complete/?id=${id}&isHealthQuestionnaire=${true}`, requestOptions).then(handleResponse);
}

//function disable(id: number) {
//    const requestOptions = { method: 'DELETE', headers: getHeader() };
//    return fetch(`${API_URL}/${API_NAME}/${id}`, requestOptions).then(handleResponse);
//}

function disable(id: number, formStatusId: FormStatusEnum) {
    const requestOptions = { method: 'DELETE', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/?id=${id}&formStatusId=${formStatusId}`, requestOptions).then(handleResponse);
}
function getByType(formTypeId: FormTemplateTypeEnum, userId?: string) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/getByType/?formTypeId=${formTypeId}&userId=${userId}`, requestOptions).then(handleResponse);
}

function createByTypeForClient(model: any) {
    const payload = {
        ...model,
        quoteTypeId: model?.quoteTypeId ?? model?.quoteType
    };
    const requestOptions = { method: "POST", headers: getHeader(), body: getBody(payload) };
    return fetch(`${API_URL}/${API_NAME}/createByTypeForClient`, requestOptions).then(handleResponse);
}